module.exports = __webpack_public_path__ + "static/media/pathway-house.92426709.png";